interface ViewImpressionLogs {
  items: NodeListOf<HTMLElement>
  itemCount: number
  maxItemCount: number
  totalItemCount: number
  pageNum: number
}

export default function viewImpressionLogs({ items, itemCount, maxItemCount, totalItemCount, pageNum }: ViewImpressionLogs) {
  let topIds: string[] = []
  let bottomIds: string[] = []

  const callback = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      const { isIntersecting, target } = entry
      if (!isIntersecting || target === undefined) return

      const parent = target.closest('[data-impression]')
      const targetPos = (target as HTMLElement).dataset.impressionTarget
      const targetIds = targetPos === 'top' ? topIds : bottomIds
      const dataAttr = (parent as HTMLElement).dataset.impression
      if (dataAttr === undefined) return

      const data = JSON.parse(dataAttr)
      const itemId: string = data.item_id

      if (!targetIds.includes(itemId)) {
        targetIds.push(itemId)
        observer.unobserve(target)
      }

      if (topIds.includes(itemId) && bottomIds.includes(itemId)) {
        window.gtag('event', 'view_item_list', {
          impression_type: 'view',
          item_count: itemCount,
          max_item_count: maxItemCount,
          total_item_count: totalItemCount,
          page_num: pageNum,
          items: [data]
        })

        topIds = topIds.filter((id) => id !== itemId)
        bottomIds = bottomIds.filter((id) => id !== itemId)
      }
    })
  }

  const observer = new IntersectionObserver(callback)

  // [windowの高さ < 計測対象要素の高さ] になると threshold: 1 は発火しないため、上下に要素を入れて交差監視をしている
  items.forEach((el) => {
    if (el.dataset.impression === undefined) return

    el.insertAdjacentHTML('afterbegin', '<div data-impression-target="top" />')
    el.insertAdjacentHTML('beforeend', '<div data-impression-target="bottom" />')

    const targets = el.querySelectorAll('[data-impression-target]')
    targets.forEach((target) => {
      observer.observe(target)
    })
  })
}
